import React, { FC } from "react";
import ModalBoxCore from "../../core-components/modal-box/ModalBoxCore";
import ModalHeader from "../../core-components/modal-box/modal-header/ModalHeader";
import ModalBody from "../../core-components/modal-box/modal-body/ModalBody";
import { Box, Link } from "@mui/material";
import palette from "../../../theme/palette";
import WhatsappLogoIcon from "../../../assets/svg-fc/WhatsappLogoIcon";
import EnvelopeSimpleIcon from "../../../assets/svg-fc/EnvelopeSimpleIcon";

import "./contactSupportModal.css";

interface iContactSupportModalProps {
	open: boolean;
	onClose: () => void;
}

const ContactSupportModal: FC<iContactSupportModalProps> = ({
	open,
	onClose,
}) => {
	return (
		<>
			<ModalBoxCore
				open={open}
				onClose={onClose}
				className="ContactSupportModal"
			>
				<ModalHeader
					modalHeaderText="Contact Support"
					closeModal={onClose}
					sx={{
						"&.modalHeader strong": {
							fontSize: { xs: 20, md: 32 },
						},
					}}
				/>
				<ModalBody>
					<Box
						sx={{
							color: palette.secondary.main
						}}>
						<Link
							id="whatsAppLink"
							href="https://wa.me/971566578765"
							target="_blank"
							sx={{
								color: palette.secondary.main,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 1,
								p: 2.5,
								width: "100%",
								border: 1,
								borderRadius: "8px",
								borderColor: "#E6E6E6",
								mb: 2,
								textDecoration: "none"
							}}>
							<WhatsappLogoIcon /> Chat on Whatsapp
						</Link>
						<Link
							id="supportEmailLink"
							href="mailto:contact@youcater.me"
							target="_blank"
							sx={{
								color: palette.secondary.main,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 1,
								p: 2.5,
								width: "100%",
								border: 1,
								borderRadius: "8px",
								borderColor: "#E6E6E6",
								mb: 2,
								textDecoration: "none"
							}}>
							<EnvelopeSimpleIcon /> contact@youcater.me
						</Link>
					</Box>
				</ModalBody>
			</ModalBoxCore>
		</>
	);
};
export default ContactSupportModal;
